import { Link } from 'react-router-dom';
import { Building2, Briefcase, BarChart3, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export function HomePage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <Building2 className="h-6 w-6" />
            <span className="text-xl font-bold">Job AI</span>
          </div>
          <div className="space-x-4">
            <Button variant="ghost" asChild>
              <Link to="/login">Sign In</Link>
            </Button>
            <Button asChild>
              <Link to="/plans">View Plans</Link>
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 text-center">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-6">
            Streamline Your Hiring Process
          </h1>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Powerful AI-driven recruitment platform to help you find and manage the best talent for your organization.
          </p>
          <Button size="lg" asChild>
            <Link to="/plans">View Plans</Link>
          </Button>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 bg-muted/50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Everything You Need to Hire Better
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="p-6">
              <Briefcase className="h-12 w-12 mb-4" />
              <h3 className="text-xl font-semibold mb-2">Job Management</h3>
              <p className="text-muted-foreground">
                Create, publish, and manage job listings with ease. Track applications and candidates in one place.
              </p>
            </Card>
            <Card className="p-6">
              <BarChart3 className="h-12 w-12 mb-4" />
              <h3 className="text-xl font-semibold mb-2">Analytics</h3>
              <p className="text-muted-foreground">
                Get insights into your hiring process with detailed analytics and reporting tools.
              </p>
            </Card>
            <Card className="p-6">
              <Shield className="h-12 w-12 mb-4" />
              <h3 className="text-xl font-semibold mb-2">SSO Integration</h3>
              <p className="text-muted-foreground">
                Secure access with enterprise-grade SSO integration and identity management.
              </p>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
}